import {JSEncrypt} from 'jsencrypt';

export default function encrypt(value: string, rsaKey: string | undefined) {
  const crypt = new JSEncrypt();
  crypt.setPublicKey(rsaKey);
  return rsaKey ? crypt.encrypt(value) : value;
}
